import React, { useState, useImperativeHandle, forwardRef } from "react";
import { LanguageContext } from "@/data/LanguageProvider";
import { Popup } from "react-vant";
import { LocationDefine, LocationInfo } from "@/data/LocationInfo";
import style from "./style.less";
import { LocalConfig } from "@/config";

const Countryshow = forwardRef((props, ref) => {
  const { langText } = React.useContext(LanguageContext);

  //visible: 控制弹出层是否展示
  const [countryVisible, setCountryVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    showCountry() {
      console.log("This is from child component");
      setCountryVisible(true);
    },
  }));
  const onContryChangeTo = (code) => {
    if (LocationDefine[code] && LocationDefine[code].url) {
      if (window.location.hostname.endsWith(LocationDefine[code].domain)) {
        return;
      }
      location.href = LocationDefine[code].url;
    }
  };
  if(!LocalConfig.availableCountryList){
    LocalConfig.availableCountryList = [LocationInfo().code];
  }
  return (
    <>
      {props.from == "HomeHeader" ? (
        <img
          src={LocationInfo().flag}
          style={{ width: "1.5rem" }}
          onClick={() => setCountryVisible(true)}
        />
      ) : props.from == "Home" ? (
        <div class={style.home_service_country} onClick={() => setCountryVisible(true)}>
          <img src={LocationInfo().flag} />
          &nbsp;{LocationInfo().name} <div class={style.triangle} />
        </div>
      ) : (
        <img
          src={LocationInfo().flag}
          style={{ width: "2.7rem" }}
          onClick={() => setCountryVisible(true)}
        />
      )}
      {/*国家弹出*/}
      <Popup
        visible={countryVisible}
        closeable
        title={langText("home_title_preference")}
        onClose={() => setCountryVisible(false)}
        closeIcon={<span style={{ color: "#a4ffe0", fontWeight: 700 }}>X</span>}
        className={style.countryPopup}
        style={{ lineHeight: "1rem" }}
      >
        <div class={style.country}>
          <div class={style.country_list}>
            <ul>
              {LocalConfig.availableCountryList.map((key) => {
                let c = LocationDefine[key];
                return (
                  <li key={c.code} onClick={() => onContryChangeTo(c.code)}>
                    <img src={c.flag} />({c.phoneStartsWith})&nbsp;&nbsp;{c.name}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Popup>
    </>
  );
});

export default Countryshow;
